const MakesSense = () => (
    <section id="makes-sense">
        <div className="container-fluid pt-4 pb-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-5"><b>Why the 6-Month Supply Makes Sense?</b></h3>
                    <h5 className="fw-light mb-4">
                        Every bottle of GlucoGen<sup>17</sup> takes over 6 weeks to craft.<br />
                        <span className="fw-bold">We don’t mass produce. We can’t.</span>
                    </h5>
                    <h5 className="fw-light mb-4">
                        The fermentation process behind GlucoGen<sup>17</sup>’s potency can’t be rushed.<br />
                        That’s why once this batch sells out, it can take 8 to 12 weeks before we have more.
                    </h5>
                    <h5 className="mb-4">
                        <span className="fw-light ">Most people come back wanting more.</span><br />
                        <b>But by the time they do…</b><br />
                        <b>we’re often out of stock.</b>
                    </h5>
                    <h5 className="fw-light mb-4">
                        There’s no backup warehouse.<br />
                        No “emergency stash.”<br />
                        No magic reorder button.<br />
                    </h5>
                    <h5 className="mb-4">
                        <span className="fw-light ">And you don’t want to find yourself mid-reset, finally feeling good…<br />
                        Only to hear: </span><b>“Sorry, we’re sold out.”</b>
                    </h5>
                </div>
            </div>
        </div>
    </section>
);

export default MakesSense;